import { Box, Button, Flex, Text } from "@radix-ui/themes"
import { Link, router, usePage } from "@inertiajs/react"
import clsx from "clsx"
import { LogOut } from "lucide-react"
import AppLogo from "@/components/app-logo"

interface SharedProps extends Record<string, unknown> {
  auth?: {
    user?: {
      email: string
    } | null
  }
}

function NavLink({
  href,
  children,
  activePattern,
}: {
  href: string
  children: React.ReactNode
  activePattern: RegExp
}) {
  const page = usePage()
  const currentPath = page.url
  const active = activePattern.test(currentPath)

  return (
    <Link
      href={href}
      className={clsx(
        "px-4 py-2 -mb-px text-sm font-semibold",
        active
          ? "bg-white border border-[var(--gray-a5)] border-b-0 rounded-t-[var(--radius-2)] text-[var(--accent-11)]"
          : "text-[var(--gray-10)]"
      )}
    >
      {children}
    </Link>
  )
}

export default function AppHeader() {
  const { auth } = usePage<SharedProps>().props

  return (
    <Box asChild>
      <header className="bg-[var(--sand-2)] border-b border-[var(--gray-a5)]">
        <Flex
          className="mx-auto max-w-[1400px]"
          px="4"
          pt="4"
          pb="0"
          direction="column"
          gap="4"
        >
          <Flex justify="between" className="w-full">
            <AppLogo />
            {auth?.user && (
              <Flex align="center" gap="3">
                <Text size="2" color="gray">
                  {auth.user.email}
                </Text>
                <Button
                  variant="ghost"
                  color="gray"
                  onClick={() => router.delete("/sign_out")}
                >
                  <LogOut size={16} />
                  Sign out
                </Button>
              </Flex>
            )}
          </Flex>

          <Flex gap="4">
            <NavLink href="/" activePattern={/^\/$/}>
              Dashboard
            </NavLink>
          </Flex>
        </Flex>
      </header>
    </Box>
  )
}
